
import { Exam, Question } from './types';

export const COLORS = {
  primary: '#F97316', // Orange-500
  secondary: '#0F172A', // Slate-900
  success: '#22c55e',
  danger: '#ef4444',
  warning: '#eab308',
};

// Helper to generate dummy questions
const generateMockQuestions = (count: number, subject: string): Question[] => {
  return Array.from({ length: count }).map((_, index) => ({
    id: `q-${index + 1}`,
    text: `Question ${index + 1} regarding ${subject}: Consider the following statements. Which of the options given below is correct?`,
    options: [
      { id: 'A', text: 'Option A statement is correct.' },
      { id: 'B', text: 'Option B statement is correct.' },
      { id: 'C', text: 'Both A and B are correct.' },
      { id: 'D', text: 'Neither A nor B is correct.' },
    ],
    correctOptionId: Math.random() > 0.5 ? 'A' : 'C',
    explanation: `The correct answer is derived from the core principles of ${subject}. Detailed analysis shows that Option A holds true because...`,
    difficulty: index % 3 === 0 ? 'Hard' : 'Medium',
    subject: subject,
  }));
};

export const CATEGORIES = [
  { 
    id: 'upsc', 
    name: 'UPSC CSE', 
    icon: 'fa-landmark',
    subcategories: [
      { id: 'gs-prelims', name: 'GS Prelims' },
      { id: 'csat', name: 'CSAT' },
      { id: 'mains', name: 'Mains' }
    ]
  },
  { 
    id: 'appsc', 
    name: 'APPSC', 
    icon: 'fa-building-columns',
    subcategories: [
      { id: 'group-1', name: 'Group 1' },
      { id: 'group-2', name: 'Group 2' }
    ]
  },
  { 
    id: 'tgpsc', 
    name: 'TGPSC', 
    icon: 'fa-building',
    subcategories: [
      { id: 'group-1', name: 'Group 1' },
      { id: 'group-2', name: 'Group 2' }
    ]
  },
  { 
    id: 'banking', 
    name: 'Banking', 
    icon: 'fa-sack-dollar',
    subcategories: [
      { id: 'po', name: 'PO' },
      { id: 'clerk', name: 'Clerk' },
      { id: 'rrb', name: 'RRB' }
    ]
  },
  { id: 'ssc', name: 'SSC', icon: 'fa-train' },
  { id: 'ca', name: 'Current Affairs', icon: 'fa-globe' },
];

const todayISO = new Date().toISOString().split('T')[0];

export const MOCK_EXAMS: Exam[] = [
  {
    id: `daily-ca-${todayISO}`,
    title: `Daily Current Affairs (${new Date().toLocaleDateString()})`,
    category: "ca",
    durationMinutes: 15,
    totalQuestions: 10,
    positiveMarks: 2,
    negativeMarks: 0.66,
    isPremium: false,
    questions: generateMockQuestions(10, 'Current Affairs'),
  },
  {
    id: 'upsc-gs-1-full',
    title: "UPSC CSE Prelims - GS Paper 1 (Mock 1)",
    category: "upsc",
    subcategory: "gs-prelims",
    durationMinutes: 120,
    totalQuestions: 20, // Reduced for demo
    positiveMarks: 2,
    negativeMarks: 0.66,
    isPremium: true, // Premium Exam
    questions: generateMockQuestions(20, 'Polity & History'),
  },
  {
    id: 'appsc-group1',
    title: "APPSC Group 1 - General Studies",
    category: "appsc",
    subcategory: "group-1",
    durationMinutes: 90,
    totalQuestions: 15,
    positiveMarks: 1,
    negativeMarks: 0.33,
    isPremium: false,
    questions: generateMockQuestions(15, 'Andhra History'),
  },
];
